import { store } from '../store';
import { mergeGraphQLData, GraphQLCompanyData } from '../graphqlSlice';

/**
 * Merge partial GraphQL data returned from a mutation into the Redux store.
 * This keeps the cached GraphQL data in sync with the backend without requiring
 * a refetch.
 */
export function mergeGraphQLUpdate(update: Partial<GraphQLCompanyData>): void {
  try {
    store.dispatch(mergeGraphQLData(update));
  } catch (err) {
    console.error('[Redux] Failed to merge GraphQL data:', err);
  }
}
